import type { Network, NetworkApiResponse } from './types';

export * from './types';

export function networkFromApi(network?: NetworkApiResponse): Network | undefined {
  if (!network) return undefined;
  return {
    mcc: network.mcc,
    mnc: network.mnc,
    countryCode: network.country_code,
    country: network.country,
    name: network.name,
  };
}
